var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Nureva {
    constructor(log) {
        this.audioState = {
            microphoneMute: false,
            microphonePickupState: 'Mono',
            microphoneGain: 6,
            speakerTrebleLevel: 90,
            speakerBassLevel: 50,
            echoReductionLevel: 'Medium',
            noiseReductionLevel: 'Medium',
            auxiliaryOutputState: 'LineLevel',
            voiceAmplificationEnabled: true,
            voiceAmplificationLevel: 20,
            voiceAmplificationAuxInLevel: 'Mic',
        };
        this.asyncHandlers = [
            {
                name: 'login',
                path: /\/api\/v1\/auth\/login/i,
                method: 'post',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    let authToken = 'YWRtaW46VUxMLVhXNS1LWDY=';
                    if ('account' in (req === null || req === void 0 ? void 0 : req.data) && 'password' in (req === null || req === void 0 ? void 0 : req.data)) {
                        authToken = btoa((req === null || req === void 0 ? void 0 : req.data.account) + ':' + (req === null || req === void 0 ? void 0 : req.data.password));
                    }
                    return this.makeResponse(req, JSON.stringify({ authParameters: authToken }));
                }),
            },
            {
                name: 'muteGet',
                path: /\/api\/v1\/audio/i,
                method: 'get',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req, JSON.stringify(this.audioState));
                }),
            },
            {
                name: 'muteSet',
                path: /\/api\/v1\/audio/i,
                method: 'patch',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    if ('microphoneMute' in (req === null || req === void 0 ? void 0 : req.data)) {
                        this.audioState.microphoneMute = req.data.microphoneMute;
                    }
                    if ('voiceAmplificationEnabled' in (req === null || req === void 0 ? void 0 : req.data)) {
                        this.audioState.voiceAmplificationEnabled = req.data.voiceAmplificationEnabled;
                    }
                    if ('voiceAmplificationLevel' in (req === null || req === void 0 ? void 0 : req.data)) {
                        this.audioState.voiceAmplificationLevel = req.data.voiceAmplificationLevel;
                    }
                    return this.makeResponse(req);
                }),
            },
            {
                name: 'volumeSet',
                path: /\/api\/v1\/audio\/volume\/change/i,
                method: 'put',
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return this.makeResponse(req);
                }),
            },
        ];
    }
    makeResponse(request, result) {
        const resultLength = result !== undefined && typeof result === 'string' ? result.length : 0;
        return {
            status: 200,
            headers: {
                'okhttp-response-source': 'NETWORK 200',
                'keep-alive': 'timeout=60',
                'content-length': `'${resultLength}'`,
                'cache-control': 'no-store',
                'okhttp-selected-protocol': 'http/1.1',
                'content-type': 'application/json',
                charset: 'utf-8',
            },
            data: result,
        };
    }
}
Nureva.emulatorType = 'httpRequestEmulator';
Nureva.key = '-O46Ipf57IeDYjwFfKWV';
